module.exports = __webpack_public_path__ + "img/option.c089ea9d.svg";